import styled from 'styled-components';
import { spacer12, screenXsMax, screenSmMin } from '@spotify-internal/encore-foundation';
export default styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-1q2yyuh-0"
})(["flex-shrink:0;margin-right:", ";@media (max-width:", "){width:", ";height:", ";}@media (min-width:", "){width:", ";height:", ";}"], spacer12, screenXsMax, function (props) {
  return props.small ? '40px' : '60px';
}, function (props) {
  return props.small ? '40px' : '60px';
}, screenSmMin, function (props) {
  return props.small ? '48px' : '96px';
}, function (props) {
  return props.small ? '48px' : '96px';
});